import React, { Component } from "react";
import { Navbar, Nav } from "react-bootstrap";
import TerminalModal from "./TerminalModal";
import Logo from "../../multi-page-attributes/images/wizard-icon.png";

export default class PageHeaderTerminal extends Component {
    render() {
        return (
            <Navbar variant="dark">
                <Navbar.Brand href="/">
                    <img src={Logo} alt={"Logo"} />
                </Navbar.Brand>
                <Navbar.Collapse>
                    <Navbar className={"ml-auto"}/>
                </Navbar.Collapse>
                <Nav.Link> { <TerminalModal /> } </Nav.Link>
            </Navbar>
        );
    }
}
